/**
 * テーブルのキーボード操作時の挙動制御
 * Enter：1つ下のセルへ移動
 * Tab：1つ横のセルへ移動
 * 矢印キー：対応した方向へセル移動
 */
import { KeyboardEvent, RefObject } from 'react';

export function handleKeyDown(e: KeyboardEvent<HTMLInputElement>, row: number, col: number, cellRefs: RefObject<HTMLInputElement>[][]
): void {
    let nextRow = row;
    let nextCol = col;
    switch (e.key) {
        case 'ArrowUp':
            nextRow = Math.max(row - 1, 0);
            break;
        case 'ArrowDown':
            nextRow = Math.min(row + 1, cellRefs.length - 1);
            break;
        case 'ArrowLeft':
            // カーソルが入力欄の右端以外の場合はフォーカスを移動しない
            if (cellRefs[row][col].current?.selectionEnd != 0) {
                return
            } else {
                nextCol = Math.max(col - 1, 0);
            }
            break;
        case 'ArrowRight':
            let selestPodition = cellRefs[row][col].current?.selectionStart || 0
            let inputLength = cellRefs[row][col].current?.value.length || 0
            // カーソルが入力欄の左端以外の場合はフォーカスを移動しない
            if (selestPodition < inputLength) {
                return
            } else {
                nextCol = Math.min(col + 1, cellRefs[0].length - 1);
            }
            break;
        case 'Enter':
            nextRow = Math.min(row + 1, cellRefs.length - 1);
            break;
        default:
            return;
    }
    e.preventDefault();
    // 微遅延でフォーカス
    setTimeout(() => {
        cellRefs[nextRow][nextCol].current?.focus();
    }, 0);
}





